import React from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import * as rest from '../../services'
import { Field, formValueSelector, reduxForm } from 'redux-form'
import {
  FormButtons,
  renderers,
} from '../../components'
import {connect, useDispatch, useSelector} from 'react-redux'
import { showErrorToast, showSuccessToast } from '../../state/toasts'

const FORM_NAME = 'repair-flag-form'
let RepairFlagForm = ({
  handleSubmit,
  pristine,
  reset,
  submitting,
    ticket,
    request_review_by_apple_true
}) => {

      const { boolean_list} = useSelector(
    (state) => state.lists
  )


  return (
    <form onSubmit={handleSubmit}>
        <ReactBootstrap.Row>
       <ReactBootstrap.Col md={4} xs={12} lg={4}>
          <Field
            component={renderers.renderSelectField}
            as="select"
            name="request_review_by_apple"
            label="Request review From apple"

          >
            {boolean_list &&
              boolean_list.map((sp) => (
                <option key={sp.key} value={sp.value}>
                  {sp.text}
                </option>
              ))}
          </Field>
          <strong>Current Value</strong> {ticket.request_review_by_apple ? 'Yes' : 'No'}
        </ReactBootstrap.Col>
        <ReactBootstrap.Col md={4} xs={12} lg={4}>
          <Field
            component={renderers.renderSelectField}
            as="select"
            name="box_required"
           label="Is Box required"
          >
            {boolean_list &&
              boolean_list.map((sp) => (
                <option key={sp.key} value={sp.value}>
                  {sp.text}
                </option>
              ))}
          </Field>
              <strong>Current Value</strong> {ticket.box_required ? 'Yes' : 'No'}
        </ReactBootstrap.Col>
        <ReactBootstrap.Col md={4} xs={12} lg={4}>
          <Field
            component={renderers.renderSelectField}
            as="select"
            name="mark_complete"
              label="Mark Complete"
          >
            {boolean_list &&
              boolean_list.map((sp) => (
                <option key={sp.key} value={sp.value}>
                  {sp.text}
                </option>
              ))}
          </Field>
             <strong>Current Value</strong> {ticket.mark_complete ? 'Yes' : 'No'}
        </ReactBootstrap.Col>
             <ReactBootstrap.Col xs={12} >
          <Field
            component={renderers.renderTextArea}

            name="hold_review_note"
              label="Review Note"
          />
        </ReactBootstrap.Col>

            </ReactBootstrap.Row>

      <FormButtons submitting={submitting} pristine={pristine} reset={reset} />
    </form>
  )
}

const selector = formValueSelector(FORM_NAME)
RepairFlagForm = connect((state) => {
  const request_review_by_apple_true = selector(state, 'request_review_by_apple')

  return {
    request_review_by_apple_true
  }
})(RepairFlagForm)

RepairFlagForm = reduxForm({
  form: FORM_NAME
})(RepairFlagForm)




export const RepairFlags = ({ ticket ,onTicketUpdate}) => {
  const dispatch = useDispatch()
    const RepairFlagFormWithData = connect((state) => ({
    initialValues: {
        request_review_by_apple:ticket.request_review_by_apple,
        mark_complete:ticket.request_review_by_apple,
        box_required:ticket.box_required
    },
        keepDirtyOnReinitialize: true,
  enableReinitialize: true, // fix issue "Redux Form - initialValues not updating with state" (http://stackoverflow.com/questions/38881324/redux-form-initialvalues-not-updating-with-state)
  }))(RepairFlagForm)
  const updateRepairFlags = (values) => {
    new rest.TicketService(ticket.url)
      .makePatchRequest(values)
      .then((response) => {
        dispatch(showSuccessToast('Success', 'Repair Flags have been updated.'))
          onTicketUpdate && onTicketUpdate(response)
      })
      .catch((errors) => {
        dispatch(showErrorToast('Error', errors))
      })
  }
  return (
    <>
      <ReactBootstrap.Card className="mt-5">
        <ReactBootstrap.Card.Title className="card-header bg-dark text-white card-header">
          <ReactBootstrap.Row>
            <ReactBootstrap.Col xs="6">Repair Flags</ReactBootstrap.Col>
          </ReactBootstrap.Row>
        </ReactBootstrap.Card.Title>
          <ReactBootstrap.Card.Body>
              {ticket && <RepairFlagFormWithData ticket={ticket} onSubmit={updateRepairFlags}/>}




          </ReactBootstrap.Card.Body>

      </ReactBootstrap.Card>


    </>
  )
}
